var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.884,
    height: 54.637,
    viewBox: "0 0 37.884 54.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 37.884,
    height: 54.637,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077",
    transform: "translate(-997 -689.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3051",
    "data-name": "Group 3051",
    transform: "translate(-235.058 123.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988",
    transform: "translate(1232.058 565.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32781",
    "data-name": "Path 32781",
    d: "M43.869,86.882v20.126l-9.493-4.177-9.493,4.177V86.882Z",
    transform: "translate(-15.434 -53.89)",
    fill: "#fc665e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32782",
    "data-name": "Path 32782",
    d: "M59.376,86.882H49.883v15.949l9.493,4.177Z",
    transform: "translate(-30.941 -53.89)",
    fill: "#fc665e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32783",
    "data-name": "Path 32783",
    d: "M34.376,86.882H24.883v6.691c2.626,3.85,6.234,3.177,9.493,1.352Z",
    transform: "translate(-15.434 -53.89)",
    fill: "#de5a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32784",
    "data-name": "Path 32784",
    d: "M49.883,86.882v7.311c2.779,3.08,8.986,3.634,9.493-1s0-6.312,0-6.312Z",
    transform: "translate(-30.941 -53.89)",
    fill: "#de5a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32785",
    "data-name": "Path 32785",
    d: "M41.388,106.046a1.517,1.517,0,0,1-.611-.129L31.9,102.009l-8.882,3.908a1.519,1.519,0,0,1-2.131-1.39V84.4A1.519,1.519,0,0,1,22.4,82.882H41.389A1.519,1.519,0,0,1,42.907,84.4v20.126a1.519,1.519,0,0,1-1.519,1.519M31.9,98.831a1.517,1.517,0,0,1,.612.129L39.87,102.2V85.92H23.921V102.2l7.363-3.239a1.517,1.517,0,0,1,.612-.129",
    transform: "translate(-12.953 -51.409)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32786",
    "data-name": "Path 32786",
    d: "M48.022,107.633a1.139,1.139,0,0,1-1.139-1.139V93.927a1.139,1.139,0,0,1,2.278,0v12.567a1.139,1.139,0,0,1-1.139,1.139",
    transform: "translate(-29.08 -57.553)",
    fill: "#4a4e59"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3069",
    "data-name": "Group 3069",
    transform: "translate(983.323 697.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3070",
    "data-name": "Group 3070",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33035",
    "data-name": "Path 33035",
    d: "M70.191,22.253a17.1,17.1,0,1,1-17.1-17.1,17.1,17.1,0,0,1,17.1,17.1",
    transform: "translate(-20.61 -2.952)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33117",
    "data-name": "Path 33117",
    d: "M70.191,22.253c0,9.443-7.655-1.175-17.1-1.175S36,31.7,36,22.253a17.1,17.1,0,1,1,34.2,0",
    transform: "translate(-20.61 -2.952)",
    fill: "#ffc648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33040",
    "data-name": "Path 33040",
    d: "M50.8,38.77A18.807,18.807,0,1,1,69.612,19.962,18.828,18.828,0,0,1,50.8,38.77m0-34.2A15.388,15.388,0,1,0,66.192,19.962,15.405,15.405,0,0,0,50.8,4.575",
    transform: "translate(-18.32 -0.661)",
    fill: "#4a4e59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3036",
    "data-name": "Group 3036",
    transform: "translate(57.375 47.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32912",
    "data-name": "Path 32912",
    d: "M44.669,36.6a3.767,3.767,0,0,0-.833-2.014,3.8,3.8,0,0,0-3.79-4.07q-.1,0-.208.006a4.236,4.236,0,0,0-6.006-.073,4.259,4.259,0,0,0-1.876-.437,4.1,4.1,0,0,0-.424.022,4.25,4.25,0,0,0-3.544,2.734,4.88,4.88,0,0,0-1.744,7.925,3.438,3.438,0,0,0-.112,1.276,3.416,3.416,0,0,0,3.389,3.071,3.494,3.494,0,0,0,.353-.018c.044,0,.09-.01.135-.017a3.258,3.258,0,0,0,1.872.588,3.308,3.308,0,0,0,.339-.017,3.266,3.266,0,0,0,1.742-.718,4,4,0,0,0,.463.027,3.8,3.8,0,0,0,.381-.019,4.012,4.012,0,0,0,3.561-3.424,3.469,3.469,0,0,0,1.427-.811,3.806,3.806,0,0,0,4.877-4.03m-4.522,3.16a2.933,2.933,0,0,0,.363-1.166.33.33,0,1,0-.658-.056,2.642,2.642,0,0,1-.421,1.115c-.009.012-.05.056-.06.069a2.545,2.545,0,0,1-1.25.818.286.286,0,0,0,0-.041,3.688,3.688,0,0,0-.153-.744,3.518,3.518,0,0,0-.65-1.211,1.717,1.717,0,0,1-.294-.638,1.848,1.848,0,0,1-.038-.741,1.892,1.892,0,0,1,.551-1.05.33.33,0,0,0-.458-.476,2.552,2.552,0,0,0-.771,2.027,3.723,3.723,0,0,0-1.106-.441,3.529,3.529,0,0,0-1.268-1.819,3.587,3.587,0,0,0-.524-.328,1.612,1.612,0,0,1-.5-.29,1.2,1.2,0,0,1-.134-1.325.33.33,0,0,0-.566-.339A1.856,1.856,0,0,0,32.1,34.7a3.515,3.515,0,0,0-1.226.1.33.33,0,1,0,.171.637,2.909,2.909,0,0,1,3.427,1.7,3.754,3.754,0,0,0-.451.016,3.7,3.7,0,0,0-1.547.512.33.33,0,1,0,.34.566,3.081,3.081,0,0,1,4.648,2.333c.007.071.01.3.009.377a3.077,3.077,0,0,1-2.763,3,2.873,2.873,0,0,1-.293.012,2.7,2.7,0,0,0,.154-.256.33.33,0,0,0-.585-.306,3.175,3.175,0,0,1-.445.6,2.291,2.291,0,0,1-1.417.664,2.316,2.316,0,0,1-1.647-.47h0a2.338,2.338,0,0,1-.65-.8.33.33,0,0,0-.588.3,2.911,2.911,0,0,0,.269.425,2.489,2.489,0,0,1-1.787-4.188.33.33,0,0,0-.48-.453,3.054,3.054,0,0,0-.388.513,3.961,3.961,0,0,1,2.519-6.6.33.33,0,1,0-.066-.657c-.1.01-.2.027-.3.045a3.3,3.3,0,0,1,4.471-1.457,4.044,4.044,0,0,0-.232.4.33.33,0,1,0,.591.294,3.353,3.353,0,0,1,.423-.642,3.3,3.3,0,0,1,5.088,0c.015.018.033.033.048.048a3.324,3.324,0,0,1,.544,1,.33.33,0,1,0,.625-.212,3.983,3.983,0,0,0-.343-.746A2.871,2.871,0,0,1,42.9,34.033a2.908,2.908,0,0,1-.019.7.329.329,0,0,0,.087.274,2.846,2.846,0,0,1,.773,1.683,2.868,2.868,0,0,1-3.6,3.067",
    transform: "translate(923.741 632.026)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32913",
    "data-name": "Path 32913",
    d: "M55.725,38.3a.33.33,0,0,0-.043-.465,1.928,1.928,0,0,0-2.118-.133,3.03,3.03,0,0,0-1.894-1.363.653.653,0,0,1-.5-.3.791.791,0,0,1,.088-.967.33.33,0,1,0-.482-.451,1.444,1.444,0,0,0-.221,1.67,3.04,3.04,0,0,0-1.943,1.1.33.33,0,1,0,.513.416A2.385,2.385,0,0,1,53.256,40a.33.33,0,1,0,.631.194,3.035,3.035,0,0,0-.04-1.9,1.262,1.262,0,0,1,1.413.044.33.33,0,0,0,.465-.043",
    transform: "translate(909.459 628.839)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32914",
    "data-name": "Path 32914",
    d: "M35.689,49.754A1.293,1.293,0,0,1,34.3,48.416a.33.33,0,0,0-.66-.024,1.957,1.957,0,0,0,1.949,2.028l.05,0a3.217,3.217,0,0,0,.493,1.626,1.749,1.749,0,0,0-.41.071,1.6,1.6,0,0,0-1.056,1,.33.33,0,0,0,.205.419.335.335,0,0,0,.107.018.33.33,0,0,0,.312-.223.931.931,0,0,1,.623-.584,1.156,1.156,0,0,1,.937.134c.058.036.126.051.186.095a2.418,2.418,0,0,0,.233.143,3.192,3.192,0,0,0,3.417-.2.33.33,0,0,0-.387-.536,2.527,2.527,0,0,1-3.81-3.025.33.33,0,0,0-.609-.255,3.162,3.162,0,0,0-.19.648",
    transform: "translate(918.455 620.65)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32915",
    "data-name": "Path 32915",
    d: "M31.622,43.475a.331.331,0,0,0-.371-.283,1.73,1.73,0,0,0-1.135.683,1.836,1.836,0,0,0-.362,1.291.33.33,0,0,0,.328.294l.036,0a.33.33,0,0,0,.292-.364,1.17,1.17,0,0,1,.234-.822,1.065,1.065,0,0,1,.7-.426.33.33,0,0,0,.283-.371",
    transform: "translate(920.806 623.6)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32916",
    "data-name": "Path 32916",
    d: "M67.241,46.947a.33.33,0,0,0-.242.4.9.9,0,0,1-.732,1.1.33.33,0,1,0,.1.652,1.56,1.56,0,0,0,1.27-1.911.331.331,0,0,0-.4-.242",
    transform: "translate(898.919 621.337)",
    fill: "#4a4e59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel6);
export default __webpack_public_path__ + "static/media/xpLevel6.56e716cbba73e6986eec2f9033318f97.svg";
export { ForwardRef as ReactComponent };